import { z } from 'zod';
import { DEFAULT_CURRENCY } from '../constants.js';
import { currencySchema } from './project.js';
import { attachmentSchema } from './attachment.js';
export const expenseStatusEnum = z.enum(['DRAFT', 'PENDING', 'PAID', 'CANCELLED']);
export const paymentMethodEnum = z.enum(['CASH', 'CARD', 'TRANSFER', 'INVOICE', 'OTHER']);
export const payeeTypeEnum = z.enum(['BUILDERS', 'DESIGNER', 'STORE', 'LAWYERS', 'OTHER']);
/** Колонки сумм — numeric(20, 8): до запятой помещается 12 знаков. */
export const EXPENSE_AMOUNT_MAX = 999_999_999_999;
const expenseAmountSchema = z.number().positive().max(EXPENSE_AMOUNT_MAX);
export const createExpenseSchema = z.object({
    contractorId: z.string().optional(),
    date: z.string().datetime().optional(),
    amount: expenseAmountSchema,
    currency: currencySchema.default(DEFAULT_CURRENCY),
    category: z.string().max(100).optional(),
    subcategory: z.string().max(100).optional(),
    expenseCategoryId: z.number().int().positive().optional(),
    status: expenseStatusEnum.default('PAID'),
    paymentMethod: paymentMethodEnum.default('CASH'),
    payeeType: payeeTypeEnum.default('OTHER'),
    description: z.string().max(1000).optional(),
    note: z.string().max(256).optional(),
    tags: z.array(z.string()).default([]),
});
export const updateExpenseSchema = createExpenseSchema.partial().extend({
    /**
     * Полная стоимость расхода до авансов. Для расхода с частичными оплатами
     * пользователь правит именно её — остаток сервер пересчитывает сам.
     */
    plannedAmount: expenseAmountSchema.optional(),
});
export const splitExpenseSchema = z.object({
    paidAmount: expenseAmountSchema,
    date: z.string().datetime().optional(),
});
export const linkedPaymentSchema = z.object({
    id: z.string(),
    amount: z.number(),
    date: z.string(),
    status: z.enum(['DRAFT', 'PENDING', 'PAID', 'CANCELLED']),
    description: z.string().nullable(),
    currency: currencySchema,
});
export const expenseCategoryRefSchema = z.object({
    id: z.number(),
    name: z.string(),
    slug: z.string(),
    parentId: z.number().nullable(),
    projectType: z.string().nullable(),
    icon: z.string().nullable(),
    color: z.string().nullable(),
    order: z.number(),
    isSystem: z.boolean(),
    parent: z.object({
        id: z.number(),
        name: z.string(),
        slug: z.string(),
        icon: z.string().nullable(),
        color: z.string().nullable(),
    }).nullable().optional(),
});
export const expenseSchema = z.object({
    id: z.string(),
    projectId: z.string(),
    contractorId: z.string().nullable(),
    date: z.string(),
    amount: z.number(),
    /** Полная стоимость до авансов; null, если частичных оплат не было. */
    plannedAmount: z.number().nullable().optional(),
    currency: currencySchema,
    category: z.string().nullable(),
    subcategory: z.string().nullable(),
    expenseCategoryId: z.number().nullable().optional(),
    expenseCategory: expenseCategoryRefSchema.nullable().optional(),
    status: expenseStatusEnum,
    paymentMethod: paymentMethodEnum,
    payeeType: payeeTypeEnum,
    description: z.string().nullable(),
    note: z.string().nullable().optional(),
    tags: z.array(z.string()),
    parentExpenseId: z.string().nullable().optional(),
    paidChildrenAmount: z.number().optional(),
    paidChildrenCount: z.number().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
    contractor: z.object({
        id: z.string(),
        name: z.string(),
    }).nullable().optional(),
    splits: z.array(linkedPaymentSchema).optional(),
    parent: linkedPaymentSchema.nullable().optional(),
    /** Только в деталях расхода (GET .../expenses/:id) — список READY-вложений. */
    attachments: z.array(attachmentSchema).optional(),
    /** Только в списке (GET .../expenses) — счётчик, без самих ссылок. */
    attachmentsCount: z.number().optional(),
});
export const expenseListSchema = z.array(expenseSchema);
//# sourceMappingURL=expense.js.map